module.exports = __webpack_public_path__ + "static/media/cotyBanner-desktop-1220x1500@1x.c3854106.jpg";